import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import CategoryHeading from '@fuww/library/src/CategoryHeading';
import SpacingContainer
from '@fuww/library/src/SpacingContainer';
import HiddenLoader from '@fuww/library/src/HiddenLoader';
import withQuery from '../../../../../lib/withQuery';
import NewsList from '../..';
import { useSiteContext } from '../../../../SiteContext';
import messages from '../../../../../lib/messages.json';
import articlesQuery
from '../../../../../lib/queries/news/articlesQuery.graphql';
import { newsListImageConfigurations }
from '../../../../../lib/imageConfigurations';
import { featuredCategoryIds } from '../../../../../lib/mainCategoryIds';

const MoreNews = ({
  data,
  categoryHeadline,
  showImage,
  showCategory,
  noBorderFirstItem,
}) => {
  const articles = data.universalNewsArticles;
  const intl = useIntl();

  return (
    <>
      {categoryHeadline
        && (
          <>
            <CategoryHeading>
              {intl.formatMessage(messages.moreNews)}
            </CategoryHeading>
            <SpacingContainer />
          </>
        )}
      <NewsList
        newsArticles={articles}
        showImage={showImage}
        showCategory={showCategory}
        noBorderFirstItem={noBorderFirstItem}
      />
    </>
  );
};

MoreNews.propTypes = {
  data: PropTypes.shape({
    universalNewsArticles: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  categoryHeadline: PropTypes.bool,
  showCategory: PropTypes.bool,
  showImage: PropTypes.bool,
  noBorderFirstItem: PropTypes.bool,
};

MoreNews.defaultProps = {
  data: {},
  categoryHeadline: true,
  showImage: null,
  showCategory: null,
  noBorderFirstItem: null,
};

const MoreNewsWithQuery = withQuery(MoreNews);

const errorMessage = 'Error while loading news articles...';

const MoreNewsWithData = ({
  categoryHeadline,
  variables,
  limit,
  categoryIds,
  offset,
  showCategory,
  showImage,
  noBorderFirstItem,
  skip,
}) => {
  const { newsboard } = useSiteContext();

  const moreNewsVariables = {
    newsboard,
    withoutDescriptionAndCreator: true,
    withoutSummaryAndLabel: true,
    sort: 'CREATED_AT',
    limit,
    categoryIds,
    offset,
    featured: false,
    imageConfigurations: newsListImageConfigurations,
    ...variables,
  };

  return (
    <MoreNewsWithQuery
      query={articlesQuery}
      variables={moreNewsVariables}
      errorMessage={errorMessage}
      categoryHeadline={categoryHeadline}
      showImage={showImage}
      showCategory={showCategory}
      noBorderFirstItem={noBorderFirstItem}
      loader={<HiddenLoader />}
      skip={skip}
    />
  );
};

MoreNewsWithData.propTypes = {
  categoryHeadline: PropTypes.bool,
  variables: PropTypes.shape({}),
  limit: PropTypes.number,
  categoryIds: PropTypes.arrayOf(PropTypes.number),
  offset: PropTypes.number,
  showCategory: PropTypes.bool,
  showImage: PropTypes.bool,
  noBorderFirstItem: PropTypes.bool,
  skip: PropTypes.bool,
};

MoreNewsWithData.defaultProps = {
  categoryHeadline: true,
  variables: null,
  limit: 3,
  categoryIds: featuredCategoryIds,
  offset: 0,
  showImage: null,
  showCategory: null,
  noBorderFirstItem: null,
  skip: false,
};

export default MoreNewsWithData;
